const SHORTHAND_HEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
const REGULAR_HEX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
const DARK_HEX_CODE = 'icon-core-subtle';
const LIGHT_HEX_CODE = 'fill-surface-default';
const RED_MULTIPLIER = 299;
const GREEN_MULTIPLIER = 587;
const BLUE_MULTIPLIER = 114;
const YIQ_DIVISOR = 1000;
const YIQ_THRESHOLD = 186;
const YIQ_THRESHOLD_HEADER_PATTERN_DARK_PRIORITY = 50;
const YIQ_THRESHOLD_HEADER_PATTERN_LIGHT_PRIORITY = 170;
const DARK = 'DARK';
const LIGHT = 'LIGHT';
export const CONTRASTS = {
  DARK,
  LIGHT
};

// Copied from:
// https://git.hubteam.com/HubSpot/ui-library/blob/0ff29f334063eb0650a3ed4367c952353260943a/ui-library-core/static/js/lib/textColor.js#L9
function hexToRgb(hex) {
  hex = hex.replace(SHORTHAND_HEX, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });
  let rgb;
  try {
    const result = REGULAR_HEX.exec(hex);
    rgb = [
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    parseInt(result[1], 16),
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    parseInt(result[2], 16),
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    parseInt(result[3], 16)];
  } catch (error) {
    rgb = [0, 0, 0];
  }
  return rgb;
}
export function getContrast(hexColor, yiqThreshold = YIQ_THRESHOLD) {
  if (!hexColor) {
    return DARK;
  }
  const [r, g, b] = hexToRgb(hexColor);
  // Based on the W3C color contrast guidance:
  // https://www.w3.org/TR/AERT/#color-contrast
  // Also see:
  // https://git.hubteam.com/HubSpot/Feedback/blob/3588837654e36565659cd13924a1a4f217b24a7d/FeedbackCore/src/main/java/com/hubspot/feedback/core/util/ColorUtils.java
  const yiq = (r * RED_MULTIPLIER + g * GREEN_MULTIPLIER + b * BLUE_MULTIPLIER) / YIQ_DIVISOR;
  if (yiq > yiqThreshold) {
    return DARK;
  }
  return LIGHT;
}
export function getHeaderPatternContrast(hexColor, isDarkPriority) {
  if (isDarkPriority) {
    return getContrast(hexColor, YIQ_THRESHOLD_HEADER_PATTERN_DARK_PRIORITY);
  }
  return getContrast(hexColor, YIQ_THRESHOLD_HEADER_PATTERN_LIGHT_PRIORITY);
}
export function getContrastColor(hexColor) {
  return getContrast(hexColor) === DARK ? DARK_HEX_CODE : LIGHT_HEX_CODE;
}